module.exports = __webpack_public_path__ + "static/media/logo.4b44e905.png";